import React from "react";

function WatebaseSupression() {
  return (
    <div class="col-lg-8 col-md-12 col-sm-12 content-side">
      <div class="service-details-content">
        <div class="inner-box">
        <h2>Water-Based Suppression System</h2>
          <figure class="image-box">
            <img
              src="/assets/images/1620943993-sulu-sondurme-sistemleri.jpg"
              alt=""
            />
          </figure>
          <div class="text">
            
            <p style={{marginTop:"1rem"}}>
              We offer a range of Water-Based Fire Protection Systems such as
              Sprinklers, Hydrants, Pre-action Systems,
              High and Medium Velocity Mist Systems, and Tank Foam Systems to
              suit the unique fire protection needs of different structures.
            </p>
 
          </div>
          {/* <div class="two-column">
            <div class="row align-items-center clearfix">
              <div class="col-lg-6 col-md-6 col-sm-12 image-column">
                <figure class="image-box">
                  <img
                    src="http://azim.commonsupport.com/Firbrigs/assets/images/service/service-8.jpg"
                    alt=""
                  />
                </figure>
              </div>
              <div class="col-lg-6 col-md-6 col-sm-12 content-column">
                <div class="text">
                  <h3>Fire Safety Tips</h3>
                  <h4>
                    Duis aute irure dolor in reprehenderit in voluptate velit
                    esse cillum.
                  </h4>
                  <ul class="list clearfix">
                    <li>Install smoke alarms in your home</li>
                    <li>Test smoke alarms every month</li>
                    <li>About a fire escape plan and practice</li>
                    <li>Think of fire before it starts</li>
                    <li>Read fire stop prevention Program</li>
                    <li>get out before the smoke gets thick</li>
                  </ul>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </div>
    </div>
  );
}

export default WatebaseSupression;
